<template>
  <!-- 排行榜 -->
  <div v-if="bodyShow" class="be-myself-rank">
    <div class="bg" >
        <img class="title" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank-top-title.png" alt="" />
        <img class="line" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/line.png" alt="" />
        <div class="title-small">「做自己节」是国内极具影响力的青年论坛，连续10年每年1月1日由新精英生涯举办，被媒体称为中国最大的“个人成长公开课”。</div>
        <div class="title-small">2021年1月1日，第10届「做自己节」如期到来<br/>全国100+分会场<br/>扫码预约观看做自己论坛在线直播</div>
        <!-- <img class="title-small" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank-text.png" alt=""> -->
        <!-- 扫码看直播 -->
        <div class="be-myself-qrcode">
            <img src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/zb.jpg" alt="">
        </div>
        <!-- 排行榜 -->
        <div class="rank">
            <img class="rank-title" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank-title.png" alt="" />
            <div class="title2">活动规则：</div>
            <div class="p">1.每1人扫码你的做自己代言人海报，即获得影响力10分。</div>
            <div class="p on">2.影响力200以上，可获得十届做自己节限量版纪念徽章（实物版）。</div>
            <!-- 自己的名词 -->
            <div class="self-rank">
                <div class="num">{{userInfo.rank}}</div>
                <img class="u-img" :src="userInfo.headimgurl" alt="">
                <div class="text text-ellipsis">{{userInfo.nickname}}</div>
                <span class="right">{{userInfo.score}}</span>
            </div>
            <!-- 总排名 -->
            <div class="total-ranking">
                <div class="total-ranking-title">
                    <span class="left">排名</span>
                    <span>昵称</span>
                    <span class="right">影响力</span>
                </div>
                <div v-for="(item,index) in list" :key="index" class="total-ranking-list">
                    <div class="left">
                        <img v-if="item.rank==1" class="rank-img" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank1.png" alt="">
                        <img v-else-if="item.rank==2" class="rank-img" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank2.png" alt="">
                        <img v-else-if="item.rank==3" class="rank-img" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/rank3.png" alt="">
                        <span v-else>{{item.rank}}</span>
                    </div>
                    <img  class="u-img" :src="item.headimgurl" alt="">
                    <span>{{item.nickname}}</span>
                    <span class="right">{{item.score}}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { queryString, getStorage, setStorage, deleteStorage,isMain} from '@/utils/tools'
import { getData,saveData,ceping81_rank_list,ceping81_info } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            cid:81,
            list:[],
            userInfo:{},
            type_obj:{},
            // 上一页面路由
            formPath: '',
        }
    },
    methods:{
        getDataInit(){
            getData({cid:this.cid}).then((data)=>{
                if(!data.data){
                    if (this.formPath === '/ceping81') {
                        this.$router.back();
                    } else {
                        this.$router.push('/ceping81');
                    }
                }else{
                    this.pullData();
                }
            });
        },
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"2024，回来做自己(σ≧∀≦σ)");
            ceping81_rank_list().then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                this.list = data.list;
                this.userInfo = data.self;
                document.title = '2024，回来做自己(σ≧∀≦σ)';
                // 获取用户信息
                ceping81_info().then((res)=>{
                    this.type_obj = {
                        uid:res.uid
                    };
                    shareCon("ceping81", this,this.type_obj);
                });
                this.bodyShow = true;
            });
        }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created(){
        this.getDataInit();
    }

}
</script>
<style lang="scss">
body{
    background-color: #FFF4EE;
}
</style>
<style lang="scss" scoped>
.be-myself-rank{
    padding: 25px;
    background-color: #FFF4EE;
    overflow: hidden;
    .bg{
        
        border: 10px solid #B70D0D;
        padding: 45px 20px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            width: 628px;
            margin: 0 20px;
            margin-bottom: 35px;
        }
        .line{
            width: 624px;
            margin: 0 16px;
            margin-bottom: 54px;
        }
        // .title-small{
        //     width: 607px;
        //     margin: 0 40px;
        //     margin-bottom: 50px;
        // }
        .title-small{
            font-size: 30px;
            font-weight: 500;
            color: #B30101;
            line-height: 56px;
            margin:0px auto 50px;
            width: 602px;
            text-align: center;
        }
        .be-myself-qrcode{
            width: 220px;
            height: 220px;
            background: #FFF4EE;
            border: 10px solid #B70D0D;
            border-radius: 20px;
            overflow: hidden;
            margin-bottom: 60px;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .rank{
            // border: 10px solid #B70D0D;
            border: 10px solid #B70D0D;
            padding: 60px 0px 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            .rank-title{
                width: 300px;
                margin-bottom: 40px;
            }
            .title2{
                font-size: 24px;
                font-weight: 600;
                color: #B50303;
                margin-bottom: 20px;
                text-align: left;
                width: 575px;
            }
            .p{
                font-size: 24px;
                font-weight: 400;
                color: #B50303;
                margin-bottom: 15px;
                width: 575px;
                text-align: left;
            }
            .p.on{
                margin-bottom: 50px;
            }
            .self-rank{
                display: flex;
                align-items: center;
                width: 550px;
                line-height: 80px;
                height: 80px;
                background: #FFFFFF;
                border: 2px solid #B70D0D;
                border-radius: 20px;
                padding: 0px 20px 0px 30px;
                font-size: 24px;
                color: #BC1F1D;
                .num{
                    font-size: 28px;
                    font-weight: 600;
                    margin-top: auto;
                }
                .u-img{
                    width: 48px;
                    height: 48px;
                    border-radius: 24px;
                    margin: auto 10px auto 20px;
                }
                .text{
                    width: 300px;
                }
                .right{
                    margin-left: auto;
                }
            }
            .total-ranking{
                margin-top: 30px;
                padding: 0px 30px 0px 24px;
                width: 100%;
                .total-ranking-title{
                    display: flex;
                    align-items: center;
                    font-size: 22px;
                    font-weight: 400;
                    color: #A9AFB3;
                    margin-bottom: 25px;
                    .left{
                        margin-right: 33px;
                    }
                    .right{
                        margin-left: auto;
                    }
                }
                .total-ranking-list{
                    display: flex;
                    align-items: center;
                    color: #BC1F1D;
                    line-height: 80px;
                    width: 100%;
                    .left{
                        font-size: 26px;
                        font-weight: 600;
                        width: 41px;
                        margin-right: 30px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .rank-img{
                            // width: 40px;
                            height: 48px;
                        }
                    }
                    .u-img{
                        width: 48px;
                        height: 48px;
                        border-radius: 24px;
                        margin-right: 10px;
                    }
                    .right{
                        margin-left: auto;
                    }
                }
            }
        }
    }
}
</style>